import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Reunion: Country = {
    identifier: "Reunion",
    name: "Reunion",
    countryCode: "RE",
    group: CountryGroup.AFRICA,
    isUNMember: false,
    flag: "🇷🇪",
    svgPath: "m 631.48975,523.8534 -0.397,0.089 -0.276,-0.032 -0.547,-0.254 -0.146,-0.169 -0.218,-0.475 0.048,-0.167 0.172,-0.294 0.39,-0.116 0.41,0.043 0.184,0.08 0.217,0.344 0.28,0.35 -0.047,0.416 z",
}
